
const defaultBoxShadow = (theme)=> (`0 0 0 1px ${theme.custom.borderGrey}`);
const grayBoxShadow = "0 0 0 3px #757575";
const pinkBoxShadow = "0 0 0 3px #8753B8";

export const fadeUnlinkedEntries = ({ entriesToFade = [], canvasEntryRefCollection = {} }) => {
	entriesToFade.forEach((id) => {
		const el = canvasEntryRefCollection[id];

		el.style.opacity = "0.7";
	});
};

export const highlightLinkedEntries = ({
	entriesToHighlight = [],
	entriesToFade = [],
	canvasEntryRefCollection = {},
}) => {
	entriesToHighlight?.forEach((element) => {
		if (element) {
			element.style.boxShadow = entriesToHighlight.length > 1 ? pinkBoxShadow : grayBoxShadow;
			element.style.opacity = "1";
		}
	});

	if (entriesToHighlight?.length > 1) {
		fadeUnlinkedEntries({ entriesToFade, canvasEntryRefCollection });
	}
};

export const removeHighlightFromEntries = ({
	canvasEntryRefCollection = {},
	hypothesisIDBeingEdited = null,
	entryIDsToSkip = [],
	theme
}) => {
	Object.keys(canvasEntryRefCollection).forEach((entryElementKey) => {
        if (!entryIDsToSkip.includes(entryElementKey)) {
			const entryElement = canvasEntryRefCollection[entryElementKey];

			if (entryElementKey !== hypothesisIDBeingEdited) {
				entryElement.style.boxShadow = null;
			}

			entryElement.style.opacity = "1";
		}
	});
};
